import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const AccountsReceivable = () => {
    return <AdminModulePage moduleKey="accounts-receivable" />;
};

export default AccountsReceivable;
